import React from 'react';
import { Navigate } from 'react-router-dom';
import { ListingRoute } from '../../../models';
import Checkout from '../../../common-pages/Checkout';
import ListingOptions from './pages/ListingOptions';
import MediaBuying from '../../../common-pages/MediaBuying';
import BusinessInfo from './pages/BusinessInfo';
import StatementOfInformation from './pages/StatementOfInformation';

export default [
  {
    path: 'business-info',
    element: BusinessInfo,
    labelId: 'addBusinessInfoLabelId',
  },
  {
    path: 'statement-of-information',
    labelId: 'statementOfInformationLabelId',
    element: StatementOfInformation,
  },
  {
    path: 'listing-options',
    element: ListingOptions,
    labelId: 'listingOptionsLabelId',
  },
  {
    path: 'media-package',
    element: MediaBuying,
    labelId: 'mediaPackageLabelId',
  },
  {
    path: 'checkout',
    element: Checkout,
    labelId: 'checkoutLabelId',
  },
  { index: true, element: <Navigate to="business-info" replace /> },
] as Array<ListingRoute>;
